import { render, staticRenderFns } from "./DistributionStats.vue?vue&type=template&id=42285dea&"
import script from "./DistributionStats.vue?vue&type=script&lang=js&"
export * from "./DistributionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports